import * as React from "react";
import {
  useGetinstructorsQuery,
  useDeleteInstructorMutation,
} from "@/store/instructorApi";
import { Button } from "../ui/button";
import { Card, CardContent, CardTitle } from "../ui/card";
import { Pencil, Trash2, X } from "lucide-react";
import InstructorForm from "./InstructorForm";

const InstructorStaff = () => {
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const [editingInstructor, setEditingInstructor] = React.useState(null);

  const { data: instructorList = [], isLoading } = useGetinstructorsQuery();
  const [deleteInstructor] = useDeleteInstructorMutation();

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this instructor?")) {
      try {
        await deleteInstructor(id).unwrap();
      } catch (error) {
        console.error("Failed to delete instructor:", error);
      }
    }
  };

  const handleEdit = (instructor) => {
    setEditingInstructor(instructor);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setEditingInstructor(null);
  };

  return (
    <div className="relative min-h-screen p-6 bg-gray-50">
      <div className="max-w-6xl mx-auto">
        <div className="flex justify-between items-center mb-6">
          <h1 className="text-3xl font-bold">Instructor Management</h1>
          <Button onClick={() => setIsModalOpen(true)}>
            Add New Instructor
          </Button>
        </div>

        {isLoading ? (
          <div className="text-center py-8">Loading...</div>
        ) : (
          <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
            {instructorList?.length > 0 &&
              instructorList.map((instructor) => (
                <Card key={instructor._id} className="relative">
                  <CardTitle className="text-xl ml-6 mt-2">
                    <span>{instructor.name}</span>
                  </CardTitle>
                  <CardContent>
                    <p className="text-gray-600 mb-4">{instructor.email}</p>
                    <div className="flex gap-2">
                      <Button
                        variant="outline"
                        size="sm"
                        onClick={() => handleDelete(instructor._id)}
                        className="text-red-600 hover:bg-red-50"
                      >
                        <Trash2 className="w-4 h-4 mr-1" />
                        Delete
                      </Button>
                      <Button
                        variant="outline"
                        size="sm"
                        onClick={() => handleEdit(instructor)}
                      >
                        <Pencil className="w-4 h-4 mr-1" />
                        Edit
                      </Button>
                    </div>
                  </CardContent>
                </Card>
              ))}
          </div>
        )}

        {/* Modal for Register/Edit Instructor */}
        {isModalOpen && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="relative bg-white rounded-lg w-full max-w-md p-4">
              <Button
                variant="ghost"
                size="icon"
                className="absolute right-2 top-2"
                onClick={handleCloseModal}
              >
                <X className="w-4 h-4" />
              </Button>
              <InstructorForm
                instructorData={editingInstructor}
                onClose={handleCloseModal}
                mode={editingInstructor ? "edit" : "create"}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default InstructorStaff;
